// extracted by mini-css-extract-plugin
export var copyable = "_k-1";
export var explainable = "_k-0";
export var negative = "_k-2";
export var positive = "_k-3";